<template>
    <div>
        <template v-for="(vendor, index) in form.vendors">
            <div class="card  mb-3">
                <div class="card-header header-sec price-header-section">
                    <div class="card-header-left header-left">
                        <!--<a href="javascript:void(0)" @click="addNewTier(index)" class="add-btn2"><i
                            class="fa fa-plus-circle"></i></a>-->
                        {{ vendor.contact_name }} ({{ vendor.company_name }})
                    </div>
                    <div class="card-header-right header-right">

                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive product-create table-card">
                        <table class="table table-custom table-nowrap table-bordered align-middle mb-0 rescol" v-columns-resizable>

                            <thead>
                                <tr class="grey-heading">
                                    <th style="width:280px;">Product</th>
                                    <th>Pieces</th>
                                    <th>Vendor Cost</th>
                                    <th>Our % Rate</th>
                                    <th>Selling</th>
                                    <th>Total Cost</th>
                                    <th>Profit</th>
                                    <th>Total Amt</th>
                                    <th>Notes</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                            <template v-if="vendor.products.length == 0">
                                <tr>
                                    <td colspan="10">No products found!</td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-for="(product, productIndex) in vendor.products">
                                    <template v-if="getRowSpan(product) > 0">
                                        <template v-for="(tier, tierIndex) in product.all_tiers">
                                            <template v-if="tier.deleted != 1 && tier.deleted != '1'">
                                                <tr :class="'first_tier_' + vendor.vendor_id">
                                                    <td v-if="tierIndex == getFirstRowIndex(product)" :class="'frst-td ven_'+ vendor.vendor_id + '_' + product.product_id + '  product_' + vendor.vendor_id"
                                                        :rowspan="getRowSpan(product)">
                                                        {{ product.product_name }}
                                                        <p v-html="product.description"></p>
                                                    </td>

                                                    <td class="text-left">
                                                        <NumberInput
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].peices"/>
                                                    </td>
                                                    <td class="tbl-lght-clr">
                                                        <NumberInput
                                                            v-on:change="calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].vendor_cost"/>
                                                    </td>
                                                    <td class="text-right">
                                                        <NumberInput
                                                            v-on:change="calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].rate"/>
                                                    </td>
                                                    <td class="tbl-lght-clr">
                                                        <NumberInput
                                                            v-on:change="selling_calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].selling"/>
                                                    </td>
                                                    <td class="tbl-lght-clr">
                                                        <NumberInput
                                                            v-on:change="cost_calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].cost"/>
                                                    </td>
                                                    <td class="tbl-lght-clr">
                                                        <NumberInput
                                                            v-on:change="profit_calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].profit"/>
                                                    </td>
                                                    <td class="tbl-lght-clr">
                                                        <NumberInput
                                                            v-on:change="amount_calculate(index, productIndex, tierIndex, 'all_tiers')"
                                                            v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].total_amt"/>
                                                    </td>

                                                    <td class="notes-td">
                                                                    <textarea rows="1" cols="35" @keyup="resizeTextArea"
                                                                              class="form-control italic-text auto-resize"
                                                                              v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].notes"></textarea>
                                                    </td>
                                                    <td>
                                                        <ul class="new-note-sec">
                                                            <li>
                                                                <input type="checkbox" @change="priceSelectionChange($event, index, productIndex, tierIndex, 'all_tiers')"
                                                                       v-model="form.vendors[index].products[productIndex].all_tiers[tierIndex].price"
                                                                       value="1">
                                                            </li>
                                                            <li><a href="javascript:void(0)"
                                                                   @click="removeTier(index, productIndex, tierIndex, 'all_tiers')"
                                                                   class="remove-btn"><i
                                                                class="fa fa-minus-circle"
                                                                aria-hidden="true"></i></a></li>
                                                            <!--<li><a href="javascript:void(0)"
                                                                @click="noteLineAdd(index, productIndex, tierIndex, 'all_tiers')"
                                                                class="add-btn2"><i class="fa fa-plus-circle"
                                                                                    aria-hidden="true"></i></a>
                                                            </li>-->
                                                        </ul>

                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>

                                </template>
                            </template>


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <div class="modal fade" id="addNotesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-soft-info">
                        <h5 class="modal-title">Add Note</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="noteLineSave(false)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" method="post" class="form form-horizontal" name="frmPriceNotes"
                              id="frmPriceNotes" enctype="multipart/form-data">
                            <div class="alert alert-danger" style="display: none;">
                                <strong>Please fill out * fields</strong>
                            </div>
                            <div class="form-body">
                                <div class="form-group">
                                    <label for="noteText">Note:</label>
                                    <input type="text" class="form-control" id="noteText" v-model="addNoteForm.notes">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger me-1" @click="noteLineSave(false)" data-dismiss="modal">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary w-sm" @click="noteLineSave(true)">Add</button>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Vue from "vue";
import NumberInput from "./NumberInput";

export default {
    name: "PriceCalculationGroupByVendor",
    components: {
        ValidationProvider,
        ValidationObserver,
        NumberInput
    },
    props: ["quote_products", "products", "quote_id", "check_price", "vendor_mail_list", "is_click", "price_notes", "quotation", "user", "role", "original_form"],
    created() {
        if(this.quote_products && this.products && this.quote_id && this.vendor_mail_list) {
            // create the form
            this.form.quote_id = this.quote_id;
            this.form.is_click = this.is_click;
            this.form.price_notes = this.price_notes;
            this.form.vendors = [];
            this.vendor_mail_list.forEach((vendor, vendorIndex) => {
                let products = [];
                this.products.forEach((product) => {
                    let newProduct = {
                        product_id: product.product_id,
                        description: product.description,
                        product_name: product.product_name,
                        quantity_unit: product.quantity_unit,
                        deleted: product.deleted ? product.deleted : null,
                        quote_tiers: [],
                        primary_tiers: [],//product.primary_tiers,
                        rest_tiers: [], // product.rest_tiers,
                        all_tiers: []
                    };
                    let vendorFromProduct = product.vendors.find((pv) => pv.vendor_id == vendor.vendor_id);

                    if(vendorFromProduct) {
                        newProduct.quote_tiers = _.cloneDeep(vendorFromProduct.quote_tiers);
                        newProduct.primary_tiers = _.cloneDeep(vendorFromProduct.primary_tiers);
                        newProduct.rest_tiers = _.cloneDeep(vendorFromProduct.rest_tiers);

                        newProduct.all_tiers = _.cloneDeep(vendorFromProduct.all_tiers);
                    }
                    products.push(newProduct);

                });
                let newVendor = {
                    vendor_id: vendor.vendor_id,
                    contact_id: vendor.contact_id,
                    company_name: vendor.company_name,
                    contact_name: vendor.contact_name,
                    products: products
                }
                this.form.vendors.push(newVendor);
            });
        }
    },
    data() {
        return {
            addNoteForm: {
                index: null,
                vendorIndex: null,
                tierIndex: null,
                tierType: null,
                notes: null
            },
            form: {
                quote_id: null,
                price_notes: null,
                is_click: null,
                vendors: [
                    {
                        vendor_id: null,
                        contact_id: null,
                        company_name: null,
                        contact_name: null,
                        products: [
                            {
                                product_id: null,
                                description: null,
                                product_name: null,
                                quantity_unit: null,
                                quote_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        price: null,
                                        deleted: null,
                                    }
                                ],
                                primary_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        price: null,
                                        deleted: null,
                                    }
                                ],
                                rest_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        price: null,
                                        deleted: null,
                                    }
                                ],
                                all_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        price: null,
                                        deleted: null,
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setPriceCalculation'
        ]),
        getRowSpan(product){
            let total = product.all_tiers.filter((t) => t.deleted != 1 && t.deleted != '1').length;

            return total;
        },
        getFirstRowIndex(product){
            let firstRowIndex = -1;

            product.all_tiers.forEach((t, index) => {
                if( t.deleted != 1 && t.deleted != '1' && firstRowIndex == -1) {
                    firstRowIndex = index;
                }
            });

            return firstRowIndex;
        },
        resizeTextArea(event){
            event.target.style.height = event.target.scrollHeight +"px";
        },
        addNewTier(index) {
            this.form.vendors[index].products.forEach((vendor, productIndex) => {
                let newTier = {
                    id: null,
                    tier_value: 0,
                    peices: 0,
                    vendor_cost: '$0',
                    rate: '0%',
                    selling: '$0',
                    cost: '$0',
                    profit: '$0',
                    total_amt: '$0',
                    notes: null,
                    price: null,
                    deleted: null,
                };
                this.form.vendors[index].products[productIndex].rest_tiers.push(newTier);
                this.form.vendors[index].products[productIndex].quote_tiers.push(newTier);
            });
            // this.setPriceCalculation(this.form);
        },
        approveQuotations(){
            this.$emit('onApproveQuotations');
        },
        savePrice(is_click){
            this.$emit('onSavePrice', is_click);
        },
        priceSelectionChange(event, index, productIndex, tierIndex, tierType) {
            // form.vendors[index].products[productIndex].rest_tiers[tierIndex].price

            if(event.target.checked) {
                //console.log(event)
                this.form.vendors.forEach((vendor, vIndex) => {
                    if(index != vIndex) {
                        vendor.products[productIndex][tierType][tierIndex].price = false
                    }
                });
            }
        },
        removeTier(index, productIndex, tierIndex, tierType) {
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete item?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        //this.form.vendors[index].products[productIndex][tierType][tierIndex].deleted = '1';
                        if(this.form.vendors[index].products[productIndex][tierType][tierIndex].id) {
                            this.form.vendors[index].products[productIndex][tierType][tierIndex].deleted = '1';
                        } else {
                            this.form.vendors[index].products[productIndex][tierType].splice(tierIndex, 1);
                        }

                        /*if(tierType == 'primary_tiers' && this.form.vendors[index].products[productIndex].rest_tiers) {
                            let rest_tiers = this.form.vendors[index].products[productIndex].rest_tiers.filter((t) => t.deleted != 1 && t.deleted != '1');
                            if(rest_tiers.length) {
                                setTimeout(() => {
                                    this.form.vendors[index].products[productIndex].primary_tiers.push(_.cloneDeep(rest_tiers[0]));
                                    this.form.vendors[index].products[productIndex].rest_tiers.splice(0, 1);
                                }, 50);

                            }
                        }*/
                    }

                }
            });
        },
        noteLineRemove(index, productIndex, tierIndex, tierType) {
            let notes = this.form.vendors[index].products[productIndex][tierType][tierIndex].notes;
            let ks = notes.split("\n");
            let checkLength = ks.length - 2;
            let dataAppend = '';
            $.each(ks, function (k) {
                if (k < checkLength) {
                    dataAppend += ks[k] + "\n";
                }
            });
            this.form.vendors[index].products[productIndex][tierType][tierIndex].notes = dataAppend;
        },
        noteLineAdd(index, productIndex, tierIndex, tierType) {
            this.addNoteForm = {
                index: index,
                productIndex: productIndex,
                tierIndex: tierIndex,
                tierType: tierType,
                notes: null
            };
            $('#addNotesModal').modal('show');
        },
        noteLineSave(isSave) {
            if (isSave) {
                let notes = this.form.vendors[this.addNoteForm.index].products[this.addNoteForm.productIndex][this.addNoteForm.tierType][this.addNoteForm.tierIndex].notes;
                let ks = notes.split("\n");
                let dataAppend = '';

                $.each(ks, function (k) {
                    dataAppend += ks[k] + "\n";
                });

                dataAppend += this.addNoteForm.notes + "\n";

                this.form.vendors[this.addNoteForm.index].products[this.addNoteForm.productIndex][this.addNoteForm.tierType][this.addNoteForm.tierIndex].notes = dataAppend;
            }
            this.addNoteForm = {
                index: null,
                productIndex: null,
                tierIndex: null,
                tierType: null,
                notes: null
            };
            $('#addNotesModal').modal('hide');
        },
        calculate(index, productIndex, tierIndex, tierType) {
            let peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;

            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");

            let vendor_cost = this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost;
            vendor_cost = vendor_cost.replace("$", "");
            let rate = this.form.vendors[index].products[productIndex][tierType][tierIndex].rate;
            rate = rate.replace("%", "");
            if (vendor_cost > 0) {
                let rate_calc = ((vendor_cost * rate) / 100).toFixed(3);
                let selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(3);
                }
                let cost = (vendor_cost * peices).toFixed(3);
                let profit = (rate_calc * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                selling = '$' + selling;
                profit = '$' + profit;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                vendor_cost = '$' + vendor_cost;
                rate = rate + '%';
                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].profit = profit;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].rate = rate;
            }
        },
        selling_calculate(index, productIndex, tierIndex, tierType) {
            let peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let selling = this.form.vendors[index].products[productIndex][tierType][tierIndex].selling;
            selling = selling.replace("$", "");
            let vendor_cost = this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost;
            vendor_cost = vendor_cost.replace("$", "");
            let difference = parseFloat(selling) - parseFloat(vendor_cost);
            if (difference > 0 && vendor_cost > 0) {
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                rate_calc = rate_calc + '%';
                this.form.vendors[index].products[productIndex][tierType][tierIndex].rate = rate_calc;
                let cost = (vendor_cost * peices).toFixed(2);
                let profit = (difference * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                profit = '$' + profit;
                selling = '$' + selling;

                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].profit = profit;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
            }
        },
        cost_calculate(index, productIndex, tierIndex, tierType) {
            let peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let cost = this.form.vendors[index].products[productIndex][tierType][tierIndex].cost;
            cost = cost.replace("$", "");
            let vendor_cost = (cost / peices).toFixed(2);
            let rate = this.form.vendors[index].products[productIndex][tierType][tierIndex].rate;
            rate = rate.replace("%", "");
            if (vendor_cost > 0) {
                let rate_calc = ((vendor_cost * rate) / 100).toFixed(3);
                let selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(3);
                }
                let profit = (rate_calc * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                vendor_cost = '$' + vendor_cost;
                selling = '$' + selling;
                cost = '$' + cost;
                profit = '$' + profit;
                total_amt = '$' + total_amt;

                this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].profit = profit;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
            }

        },
        profit_calculate(index, productIndex, tierIndex, tierType) {
            let peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let profit = this.form.vendors[index].products[productIndex][tierType][tierIndex].profit;
            profit = profit.replace("$", "");
            let vendor_cost = this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost;
            vendor_cost = vendor_cost.replace("$", "");
            let profit_differnce = (profit / peices);
            if (vendor_cost > 0 && profit_differnce > 0) {
                let selling = this.form.vendors[index].products[productIndex][tierType][tierIndex].selling;
                selling = selling.replace("$", "");
                selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(3);
                }
                let difference = (parseFloat(selling) - parseFloat(vendor_cost)).toFixed(2);
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                let cost = (vendor_cost * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                rate_calc = rate_calc + '%';
                selling = '$' + selling;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                profit = '$' + profit;

                this.form.vendors[index].products[productIndex][tierType][tierIndex].rate = rate_calc;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].profit = profit;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
            }
        },
        amount_calculate(index, productIndex, tierIndex, tierType) {
            let peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let total_amt = this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt;
            total_amt = total_amt.replace("$", "");
            peices = this.form.vendors[index].products[productIndex][tierType][tierIndex].peices;
            peices = peices.replace("$", "");
            let profit = this.form.vendors[index].products[productIndex][tierType][tierIndex].profit;
            profit = profit.replace("$", "");
            if (profit > 0) {
                let cost = (parseFloat(total_amt) - parseFloat(profit)).toFixed(2);
                let selling = (total_amt / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (total_amt / peices).toFixed(2);
                } else {
                    selling = (total_amt / peices).toFixed(3);
                }
                let vendor_cost = (cost / peices).toFixed(2);
                let difference = (parseFloat(selling) - parseFloat(vendor_cost)).toFixed(2);
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                selling = '$' + selling;
                cost = '$' + cost;
                vendor_cost = '$' + vendor_cost;
                total_amt = '$' + total_amt;
                rate_calc = rate_calc + '%';

                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].rate = rate_calc;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
            } else if (this.form.vendors[index].products[productIndex][tierType][tierIndex].rate > 0) {
                let selling = (total_amt / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (total_amt / peices).toFixed(2);
                } else {
                    selling = (total_amt / peices).toFixed(3);
                }
                profit = (total_amt / selling).toFixed(2);
                let cost = (parseFloat(total_amt) - parseFloat(profit)).toFixed(2);
                let vendor_cost = (cost / peices).toFixed(2);
                selling = '$' + selling;
                profit = '$' + profit;
                vendor_cost = '$' + vendor_cost;
                total_amt = '$' + total_amt;
                cost = '$' + cost;

                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].profit = profit;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
            } else {
                let cost = total_amt;
                let selling = (cost / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (cost / peices).toFixed(2);
                } else {
                    selling = (cost / peices).toFixed(3);
                }
                let vendor_cost = selling;
                selling = '$' + selling;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                vendor_cost = '$' + vendor_cost;

                this.form.vendors[index].products[productIndex][tierType][tierIndex].selling = selling;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].cost = cost;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.vendors[index].products[productIndex][tierType][tierIndex].vendor_cost = vendor_cost;
            }
            return false;
        },
        updatePrice(form) {
            this.$emit('onWatchUpdateForm', form);
        },
    },
    watch: {
        "form.vendors": {
            handler: function (after, before) {
                if(this.original_form) {
                    let form = _.cloneDeep(this.original_form);
                    form.products.forEach((product, index) => {
                        product.vendors.forEach((vendor, vendorIndex) => {
                            let afterVendor = after.find((x) => x.vendor_id == vendor.vendor_id);
                            if(afterVendor && afterVendor.products) {
                                let afterProduct = afterVendor.products.find((x) => x.product_id == product.product_id);
                                if(afterProduct) {
                                    if(vendor.quote_tiers.length != afterProduct.quote_tiers.length) {
                                        form.products[index].vendors[vendorIndex].quote_tiers = afterProduct.quote_tiers;
                                    }

                                    if(vendor.all_tiers.length != afterProduct.all_tiers.length) {
                                        form.products[index].vendors[vendorIndex].all_tiers = afterProduct.all_tiers;
                                    }
                                    // form.products[index].vendors[vendorIndex].primary_tiers = afterProduct.primary_tiers;
                                    // form.products[index].vendors[vendorIndex].rest_tiers = afterProduct.rest_tiers;
                                    form.products[index].vendors[vendorIndex].all_tiers = afterProduct.all_tiers;
                                }
                            }
                        });
                    });
                    if(!_.isEqual(form, this.original_form)) {
                        this.updatePrice(form);
                    }
                }
            },
            deep: true,
        },
        'form': {
            handler: function (after, before) {
                // Wait until the template has updated
                this.$nextTick(() => {
                    [...document.querySelectorAll('textarea')].forEach(textarea => {
                        this.resizeTextArea({ target: textarea });
                    });
                });
            },
            deep: true,
        },
    }
}
</script>

<style scoped>

</style>
